var _defs, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eef8ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,11H0V0H11ZM2,9H9V2H2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,11H13V0H24ZM15,9h7V2H15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,24H0V13H11ZM2,22H9V15H2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,20H22V15H20v3H14V13h2v3h2V13h6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,24H14V20h2v2h8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 3,
    transform: "translate(4 4)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 3,
    transform: "translate(17 4)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 3,
    transform: "translate(4 17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryicon);
export default __webpack_public_path__ + "static/media/inventoryicon.b4f4635f95c3a2205f6509eaa173f918.svg";
export { ForwardRef as ReactComponent };